export default "__VITE_ASSET__IQtCouhH__"